import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iRevokeAdminState {
    email: string;
    isLoading: boolean;
    response: any;
    message: string;
}
const initialState: iRevokeAdminState = {
    email: '',
    isLoading: false,
    response: [],
    message: ""
}
export const postRevokeAdminAPI = createAsyncThunk(
    'POST_REVOKE_ADMIN',
    async (user: { email: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/revoke-admin/'


            const response = await axiosInstance.patch(
                `${djangoEndpoint}${pathParam}`,
                {
                    email: user.email,
                },
                {
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const revokeAdminSlice = createSlice({
    name: 'revokeAdmin',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postRevokeAdminAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(postRevokeAdminAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(postRevokeAdminAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.email = '';
                state.response = action.payload;
            });
    }
});

export default revokeAdminSlice.reducer;